import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import Vue from 'vue';
import Vuex from 'vuex';
import utils from './common/utils';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    userInfo: utils.getSession('userInfo') ? JSON.parse(utils.getSession('userInfo')) : {},
    publishBookCont: utils.getSession('publishBookCont') ? JSON.parse(utils.getSession('publishBookCont')) : {},
    appSetting: utils.getSession('appSetting') ? JSON.parse(utils.getSession('appSetting')) : {},
    cinemaOrder: utils.getLocal('cinemaOrder') ? JSON.parse(utils.getLocal('cinemaOrder')) : [],
    reservationTotal: utils.getSession('reservationTotal') ? JSON.parse(utils.getSession('reservationTotal')) : [],
    imgPoster: utils.getLocal('imgPoster') ? JSON.parse(utils.getLocal('imgPoster')) : {
      type: 'Image',
      data: []
    },
    videoPoster: utils.getLocal('videoPoster') ? JSON.parse(utils.getLocal('videoPoster')) : {
      type: 'Video',
      data: []
    },
    customizePoster: utils.getLocal('customizePoster') ? JSON.parse(utils.getLocal('customizePoster')) : {
      type: "Customize",
      data: []
    },
    transitionList: utils.getSession('transitionList') ? JSON.parse(utils.getSession('transitionList')) : [],
    language: utils.getLocal('language') ? utils.getLocal('language') : 'cn',
    // nologinRedirect: utils.getSession('nologinRedirect') ? JSON.parse(utils.getSession('nologinRedirect')) : '',
    poster: [{
      type: 'vertical',
      images: [{
        src: '',
        id: null
      }]
    }, {
      type: 'vertical',
      images: [{
        src: '',
        id: null
      }]
    }],
    readingImg: utils.getSession('readingImg') ? JSON.parse(utils.getSession('readingImg')) : [],
    readingMessage: utils.getSession('readingMessage') ? utils.getSession('readingMessage') : ''
  },
  getters: {
    listOrder: function listOrder(state) {
      return state.cinemaOrder.map(function (item) {
        return item.OID;
      });
    },
    //馆员管理应用通过配置做不同应该的显示与隐藏（黄浦区教育学院想把年度报表由校际联盟转移到馆员管理）
    librarianManaShowApp: function librarianManaShowApp() {
      return process.env.VUE_APP_LibrarianManaShowApp;
    }
  },
  mutations: {
    //存储用户信息
    SET_USER_INFO: function SET_USER_INFO(state, val) {
      state.userInfo = val;
      utils.setSession('userInfo', val);
    },
    //存储用户已经填写过的赠书信息（用户没绑定联系方式时，再赠书发布页面填写完部分赠书信息之后需跳转到详情页绑定联系方式，防止返回发布页时填写的消息丢失）
    SET_PUBLISH_BOOK_CONT: function SET_PUBLISH_BOOK_CONT(state, val) {
      state.publishBookCont = val;
      utils.setSession('publishBookCont', val);
    },
    //存储模块配置信息
    SET_APP_SETTING: function SET_APP_SETTING(state, val) {
      state.appSetting = val;
      utils.setSession('appSetting', val);
    },
    //添加点播（知识影院）
    SET_CINEMA_ORDER: function SET_CINEMA_ORDER(state, val) {
      //console.log(val)
      var item = state.cinemaOrder.filter(function (x) {
        return x.OID == val.OID;
      })[0];

      if (item) {
        return;
      }

      state.cinemaOrder.push(val);
      console.log(state.cinemaOrder);
      utils.setLocal('cinemaOrder', state.cinemaOrder);
    },
    //删除点播（知识影院）
    REMOVE_CINEMA_ORDER: function REMOVE_CINEMA_ORDER(state, val) {
      var item = state.cinemaOrder.filter(function (x) {
        return x.OID == val.OID;
      })[0];

      if (!item) {
        return;
      }

      console.log(state.cinemaOrder);
      var index = state.cinemaOrder.map(function (x) {
        return x.OID;
      }).indexOf(item.OID);
      state.cinemaOrder.splice(index, 1);
      utils.setLocal('cinemaOrder', state.cinemaOrder);
    },
    //清空点播（知识影院）
    CLEAR_CINEMA_ORDER: function CLEAR_CINEMA_ORDER(state, val) {
      state.cinemaOrder = [];
      utils.removeLocal('cinemaOrder');
    },
    //存储用户信息
    SET_RESERVATION_TOTAL: function SET_RESERVATION_TOTAL(state, val) {
      state.reservationTotal = val;
      utils.setSession('reservationTotal', val);
    },
    //知识海报图片
    SET_IMG_POSTER: function SET_IMG_POSTER(state, val) {
      var src = val.src;
      var index = val.index;
      var type = val.type;

      if (index != undefined) {
        var o = {
          image: src,
          id: new Date().getTime() + Math.random(),
          type: type
        };

        if (src) {
          //修改
          state.imgPoster.data.splice(index, 1, o);
        } else {
          //删除
          state.imgPoster.data.splice(index, 1);
        }
      } else {
        //添加
        state.imgPoster.data.push({
          src: src,
          id: new Date().getTime() + Math.random()
        });
      }

      console.log('存入缓存');
      utils.setLocal('imgPoster', state.imgPoster);
    },
    CLEAR_IMG_POSTER: function CLEAR_IMG_POSTER(state, val) {
      state.imgPoster.data = val;
      utils.removeLocal('imgPoster');
    },
    //知识海报视频
    SET_VIDEO_POSTER: function SET_VIDEO_POSTER(state, val) {
      var src = val.src;
      var index = val.index;
      var type = val.type;

      if (index != undefined) {
        var o = {
          image: src,
          id: new Date().getTime() + Math.random(),
          type: type
        };

        if (src) {
          //修改
          state.videoPoster.data.splice(index, 1, o);
        } else {
          //删除
          state.videoPoster.data.splice(index, 1);
        }
      } else {
        //添加
        console.log('添加');
        console.log(state.videoPoster);
        console.log(src);
        state.videoPoster.data.push({
          src: src,
          id: new Date().getTime() + Math.random()
        });
      }

      utils.setLocal('videoPoster', state.videoPoster);
    },
    CLEAR_VIDEO_POSTER: function CLEAR_VIDEO_POSTER(state, val) {
      state.videoPoster.data = val;
      utils.removeLocal('videoPoster');
    },
    ////知识海报自定义
    SET_CUSTOMIZE_POSTER: function SET_CUSTOMIZE_POSTER(state, val) {
      state.customizePoster.data = val;
      utils.setLocal('customizePoster', state.customizePoster);
    },
    CLEAR_CUSTOMIZE_POSTER: function CLEAR_CUSTOMIZE_POSTER(state, val) {
      state.customizePoster.data = val;
      utils.removeLocal('customizePoster');
    },
    SET_TRANSITION_LIST: function SET_TRANSITION_LIST(state, val) {
      state.transitionList = val;
      utils.setSession('transitionList', val);
    },
    //设置当前语言
    SET_LANGUAGE: function SET_LANGUAGE(state, val) {
      state.language = val;
      utils.setLocal('language', val);
    },
    //存储阅读圈上传图片
    SET_READINGIMG: function SET_READINGIMG(state, val) {
      state.readingImg = val;
      utils.setSession('readingImg', val);
    },
    //存储阅读圈评论内容
    SET_READINGMESSAGE: function SET_READINGMESSAGE(state, val) {
      state.readingMessage = val;
      utils.setSession('readingMessage', val);
    } // SET_NOLOGIN_REDIRECTURL(state,val) {
    //     state.nologinRedirect = val;
    //     utils.setSession('nologinRedirect', val);
    // },
    // CLEARE_NOLOGIN_REDIRECTURL(state,val) {
    //     state.nologinRedirect = '';
    //     utils.removeSession('nologinRedirect');
    // }

  },
  actions: {}
});